module.exports = __webpack_public_path__ + "img/music.0e858bcc.svg";